// ============================================
// Author						: Prabakaran
// Description			:
// Date							:
// ============================================
import { Component, OnInit, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { UtilitesService } from '@systemic/services';
import { AuthService } from '@service/auth/auth.service';

declare let mLayout: any;
@Component({
  selector: 'nav-header',
  templateUrl: './nav-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavheaderComponent implements OnInit {

  constructor(private lib: UtilitesService, private srvAuth: AuthService, private zone: NgZone) { }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      mLayout.initHeader();
    });
  }
  OnLogout() {
    this.lib.notify
      .confirm(`Do you want to Logout?`, 'Confirm Logout').subscribe(isYes => {
        if (isYes) {
          this.lib.cookie.remove('Config.UserInfo');
          this.lib.cookie.remove('Config.BranchInfo');
          this.lib.cookie.remove('Config.CompanyInfo');
          const apiserver = this.lib.TokenContext.ApiServer;
          const authserver = this.lib.TokenContext.AuthServer;
          apiserver.ApiKey = '';
          apiserver.IsTokenReady = false;
          authserver.AuthKey = '';
          authserver.Url = '';
          authserver.ProjectKey = '';
          this.lib.cookie.set('Config.ApiServer', apiserver);
          this.lib.cookie.set('Config.AuthServer', authserver);
          this.lib.router.navigate(['/auth/login']);
        }
      });
  }
}




// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/nav-header/nav-header.component.ts